import { render, staticRenderFns } from "./SampleValues.vue?vue&type=template&id=3feb6598&"
import script from "./SampleValues.vue?vue&type=script&lang=ts&"
export * from "./SampleValues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports